<template>
  <b-row :class="marginBottom ? marginBottom : 'pb-4 pt-3'">
    <b-col cols="12" offset-sm="1" sm="3">
      <label>{{ label }}</label>
    </b-col>
    <b-col cols="12" sm="7">
      <b-form-checkbox
        :id="handle"
        :name="handle"
        size="lg"
        v-model="inputValue"
        @input="updateField"
      >
        {{ checkboxLabel }}
      </b-form-checkbox>
      <!-- eslint-disable-next-line vue/no-v-text-v-html-on-component -->
      <b-form-text v-if="desc" v-html="desc"></b-form-text>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: 'CheckboxRowWithLabel',
  props: {
    valueFromDb: { type: Boolean, default: false },
    handle: { type: String, default: null },
    label: { type: String, default: null },
    checkboxLabel: { type: String, default: null },
    desc: { type: String, default: null },
    showElement: { type: Boolean, default: true },
    marginBottom: { type: String, default: null },
  },
  data() {
    return {
      inputValue: null,
    };
  },
  created() {
    this.inputValue = this.valueFromDb;
  },
  methods: {
    updateField() {
      this.$emit('update-field', this.inputValue);
    },
  },
};
</script>
